import { useKeycloak } from '@react-keycloak/web'

const RenderOnAnonymous = ({ children }) => {
    const { keycloak } = useKeycloak()

    return !keycloak.authenticated ? children : null
}

export default RenderOnAnonymous
